// extracted by mini-css-extract-plugin
module.exports = {"modal":"Edit_modal__1UGoy","wrapper":"Edit_wrapper__22eS9","wrapper_button":"Edit_wrapper_button__3_THC","loading":"Edit_loading__AOuxD"};